export const onlyPositiveFloat = /[^0-9.]/g
